module.exports = __webpack_public_path__ + "static/media/GoLedger.662b1798.png";